import React from "react";

import { footer } from "../data";

import FooterLogo from "../assets/img/hp_logo_white.png";

const Footer = () => {
  return (
    <footer className="section bg-[#5E514B] text-white">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-between border-b border-opacity-75 border-white pb-7 lg:pb-14 mb-14">
          <div className="mb-6 lg:mb-0 ">
            <img src={FooterLogo} alt="" width={60} />

            {/* <h1 className="text-3xl text-white  font-bold">HP Enterprises</h1> */}
          </div>
          <div className="flex gap-x-4">
            {footer.social.map((item, index) => {
              return (
                <div
                  key={index}
                  className="w-12 h-12 text-2xl bg-[#99887C] hover:bg-[#550A0F] rounded-full flex justify-center items-center transition"
                >
                  <a href={item.href} target="new">
                    {item.icon}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
        <p className="text-center">&copy; {footer.copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;
